module.exports = __webpack_public_path__ + "static/media/max-schultz-win.da106c83.png";